import { render } from "./OurPartners.vue?vue&type=template&id=5b2b42c3&scoped=true"
import script from "./OurPartners.vue?vue&type=script&lang=js"
export * from "./OurPartners.vue?vue&type=script&lang=js"

import "./OurPartners.vue?vue&type=style&index=0&id=5b2b42c3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2b42c3"]])

export default __exports__